import { apiEndpoint } from '@/configs/api/api-configs'
import { reactive } from '@vue/composition-api'

export function privilegeHistoryModel() {
  const fetchPrivilegeHistoryList = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeHistory/List`,
    method: 'POST',
    xRequest: '',
    payload: {
      Privilege_Id: 26,
      Page: 1,
      Limit: 100,
      Filters: [
        {
          Seq: 1,
          Key: 'query',
          Value: '',
        },
      ],
      Ordering: [
        {
          Seq: 1,
          Key: 'tx_time',
          Direction: 'desc',
        },
      ],
    },
  })

  return {
    fetchPrivilegeHistoryList,
  }
}
